import { Maximize2, Hexagon, Ruler, Crosshair, BarChart2, BoxSelect, Layers, Search, User } from "lucide-react";

// ── Tool reference list (icons match the actual header toolbar) ────────────
const TOOLS = [
  {
    Icon: Maximize2,
    label: "Fullscreen",
    desc: "Expand the viewer to fill the screen.",
  },
  {
    custom: "3D",
    label: "2D / 3D View",
    desc: "Switch between top-down map and free-tilt globe perspective.",
  },
  {
    Icon: Hexagon,
    label: "Area & Perimeter",
    desc: "Draw a polygon on the globe to measure its area and perimeter.",
  },
  {
    Icon: Ruler,
    label: "Measure Distance",
    desc: "Click two points on the globe to measure the distance between them.",
  },
  {
    Icon: Crosshair,
    label: "Point Inspector",
    desc: "Click any data point to read its deformation value and metadata.",
  },
  {
    Icon: BarChart2,
    label: "Profile Viewer",
    desc: "Draw a line across the map to see a cross-section of ground movement.",
  },
  {
    Icon: BoxSelect,
    label: "3D Surface Modeler",
    desc: "Generate an interpolated 3D deformation surface over a selected area.",
  },
  {
    Icon: Layers,
    label: "Layers Panel",
    desc: "Select a project and toggle datasets on or off. Drag legend handles to filter by deformation range.",
  },
  {
    Icon: Search,
    label: "Search",
    desc: "Search for a place by name and fly the globe to it.",
  },
  {
    Icon: User,
    label: "User Menu",
    desc: "View your account details or sign out.",
  },
];

// ── OnboardingModal ────────────────────────────────────────────────────────
export function OnboardingModal({ visible, onStart }) {
  if (!visible) return null;
  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 9000,
      background: "rgba(0,0,0,0.55)",
      backdropFilter: "blur(4px)",
      WebkitBackdropFilter: "blur(4px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 20,
    }}>
      <div style={{
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
        maxWidth: 520, width: "100%",
        maxHeight: "90vh",
        overflow: "hidden",
        display: "flex", flexDirection: "column",
        fontFamily: "'Inter','Helvetica Neue',sans-serif",
      }}>

        {/* ── Dark header ── */}
        <div style={{ background: "#232231", padding: "22px 26px 20px", flexShrink: 0 }}>
          <img
            src="/inspekt-logo.jpeg"
            alt="InSpekt"
            style={{ height: 34, borderRadius: 6, display: "block", marginBottom: 14 }}
          />
          <p style={{
            color: "#f9fafb", fontSize: 17, fontWeight: 700,
            margin: 0, lineHeight: 1.3, letterSpacing: "-0.01em",
          }}>
            Getting started
          </p>
        </div>

        {/* ── Tool list ── */}
        <div style={{ overflowY: "auto", flex: 1 }}>
          {TOOLS.map(({ Icon, custom, label, desc }) => (
            <div key={label} style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 12,
              padding: "9px 22px",
              borderBottom: "1px solid #f3f4f6",
            }}>
              <span style={{
                width: 28, height: 28,
                borderRadius: 7,
                background: "#232231",
                display: "flex", alignItems: "center", justifyContent: "center",
                flexShrink: 0,
                color: "#9ca3af",
              }}>
                {Icon
                  ? <Icon size={14} />
                  : <span style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af" }}>{custom}</span>
                }
              </span>
              <div style={{ flex: 1, paddingTop: 2 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#111827", marginBottom: 2 }}>
                  {label}
                </div>
                <div style={{ fontSize: 11, color: "#6b7280", lineHeight: 1.5 }}>
                  {desc}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ── Footer ── */}
        <div style={{
          padding: "14px 22px",
          display: "flex",
          justifyContent: "flex-end",
          borderTop: "1px solid #f3f4f6",
          flexShrink: 0,
        }}>
          <button
            onClick={onStart}
            style={{
              background: "#6366f1", color: "#fff",
              border: "none", borderRadius: 8,
              padding: "9px 22px",
              fontSize: 13, fontWeight: 600,
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(99,102,241,0.35)",
              letterSpacing: "0.01em",
            }}
          >
            Exit — Get Started
          </button>
        </div>
      </div>
    </div>
  );
}

// OnboardingTour kept as no-op for backward compatibility
export function OnboardingTour() { return null; }
